/* eslint-disable @typescript-eslint/consistent-type-assertions */
import * as React from 'react';

import { Styled } from './body-copy.styles';
import type { BodyCopyProps } from './body-copy.types';

export const BodyCopy = React.forwardRef<HTMLParagraphElement, BodyCopyProps>(
  (
    {
      children,
      className,
      ellipsis,
      fontWeight = 'regular',
      lineHeight,
      noMargin,
      size = 'medium',
      sizeConfined,
      sizeWide,
      ...props
    },
    forwardedRef
  ): JSX.Element => {
    const fullText = typeof children === 'string' ? children : undefined;

    return (
      <Styled.BodyCopy
        $ellipsis={ellipsis}
        $fontWeight={fontWeight}
        $lineHeight={lineHeight}
        $noMargin={noMargin}
        $size={size}
        $sizeConfined={sizeConfined}
        $sizeWide={sizeWide}
        className={className}
        data-xds="BodyCopy"
        ref={forwardedRef}
        title={ellipsis && fullText ? fullText : undefined}
        {...props}
      >
        {children}
      </Styled.BodyCopy>
    );
  }
);

BodyCopy.displayName = 'BodyCopy';

export const InlineBodyCopy = React.forwardRef<HTMLSpanElement, BodyCopyProps>(
  (props, ref): JSX.Element => (
    <BodyCopy
      as="span"
      {...props}
      ref={ref as React.Ref<HTMLParagraphElement>}
    />
  )
);

InlineBodyCopy.displayName = 'InlineBodyCopy';
